import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import placeholderImage from '../../../assets/images/placeholder.jpg';
import placeholderBackground from '../../../assets/images/placeholder-background.png';

import { config } from '../../../config/index';

const { SERVER_URL } = config;

const ItemCard = ({ item }) => {
  const [quantityLeft, setQuantityLeft] = useState(0);
  const [bgUrl, setBgUrl] = useState(`${SERVER_URL}/${item.images[0].url}`);
  useEffect(() => {
    let total = item.redeemed.reduce(
      (total, redeem) => total + redeem.quantity,
      0
    );
    setQuantityLeft(item.quantity - total);
  }, [item]);

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      // The image loaded successfully. You can optionally do something here.
    };
    img.onerror = () => {
      // If the image fails to load, update the background URL to a fallback.
      setBgUrl(placeholderBackground);
    };
    img.src = bgUrl;
  }, [bgUrl]);

  return (
    <div
      className="bg-white adjust-shadow"
      style={!item.active ? { border: '1px solid red' } : {}}
    >
      <div
        className="img-responsive"
        style={{
          position: 'relative',
          backgroundImage: `url(${
            item.images.length > 0 ? `${bgUrl}` : placeholderBackground
          })`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundSize: 'contain',
          height: '250px',
        }}
      >
        {quantityLeft <= 0 && (
          <div
            style={{
              height: '20px',
              position: 'absolute',
              bottom: '0',
              fontSize: '0.75rem',
              backgroundColor: '#dd7b7c',
            }}
            className="w-100 text-center text-white"
          >
            FULLY REDEEMED
          </div>
        )}
      </div>
      <div className="pt-2 pb-3 px-3">
        <div className="d-flex flex-column">
          <h6
            style={{
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
            className={`p-0 m-0 ${item.active ? '' : 'text-danger'}`}
          >
            {item.name}
          </h6>
          <div className="text-brand mt-1" style={{ fontSize: '0.8rem' }}>
            {item.type === 'redeemable'
              ? `${item.redeem_points} POINTS`
              : 'FREE'}
          </div>
        </div>
        <hr style={{ marginTop: '0.7rem', marginBottom: '0.7rem' }} />
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            {item.redeemed.length > 0 && (
              <>
                {_.uniqBy(
                  item.redeemed.map((associate) => ({
                    quantity: associate.quantity,
                    ...associate.associate,
                  })),
                  'id'
                )
                  .slice(0, 3)
                  .map((associate, index) => (
                    <div
                      key={index}
                      className="border"
                      style={{
                        height: '25px',
                        width: '25px',
                        borderRadius: '25px',
                        backgroundImage: `url(${
                          associate.image ? associate.image : placeholderImage
                        })`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center center',
                        backgroundSize: 'cover',
                      }}
                    ></div>
                  ))}
                {_.uniqBy(
                  item.redeemed.map((associate) => ({
                    quantity: associate.quantity,
                    ...associate.associate,
                  })),
                  'id'
                ).length > 3 && (
                  <small className="text-brand ps-1">
                    +
                    {_.uniqBy(
                      item.redeemed.map((associate) => ({
                        quantity: associate.quantity,
                        ...associate.associate,
                      })),
                      'id'
                    ).length - 3}{' '}
                    more
                  </small>
                )}
              </>
            )}
          </div>

          <span
            className={
              `badge rounded-pill ` +
              (quantityLeft <= 0 ? 'text-bg-secondary' : 'text-white bg-brand')
            }
          >
            {quantityLeft} Left
          </span>
        </div>
      </div>
    </div>
  );
};

export default ItemCard;
